module.exports = {
  commonBase: {
    wz0: "运营类型",
    wz1: "运营",
    wz2: "运维",
    wz3: "星充直营",
    wz4: "加盟直营",
    wz5: "联营",
    wz6: "他营",
    wz7: "人人电站",
    wz8: "私桩",
    wz9: "非私桩",
    wz10: "全部",
  },
  PowerBoxDetail: {
    title1: "基础信息",
    title2: "配电柜编号",
    title3: "设备名称",
    title4: "硬件属性",
    title5: "当前固件型号",
    title6: "当前版本号",
    title7: "电表数据",
    value1: "A相电流",
    value2: "A相电压",
    value3: "B相电流",
    value4: "B相电压",
    value5: "C相电流",
    value6: "C相电压",
    value7: "A相电量",
    value8: "B相电量",
    value9: "C相电量",
    value10: "A相功率",
    value11: "B相功率",
    value12: "C相功率",
    value13: "三相总电量",
    value14: "总电量-峰",
    value15: "总电量-尖",
    value16: "总电量-谷",
    value17: "总电量-平",
    value18: "三相总功率",
    wz1: "固件信息",
  },
  powerBoxList: {
    title1: "配电柜编号",
    placeholder1: "请输入配电柜编号",
    placeholder2: "请输入电站名称",
    title2: "电站名称",
    btn1: "查询",
    title3: "配电柜编号",
    title4: "电站名称",
    title5: "当前固件型号",
    title6: "当前版本号",
    title7: "电表编号",
    title8: "额定功率",
    action: "操作",
    title9: "基础信息",
    title10: "设备列表",
    title11: "设备快速查询",
    title12: "基础信息",
    title13: "当前状态",
    title14: "绑定推送人",
    wz1: "固件信息",
    wz2: "电表编号",
    wz3: "地区",
  },
  configModify: {
    title1: "配置字段(字段范围)",
    title2: "设备配置",
    title3: "平台配置",
    title4: "订单详情",
  },
  logDetail: {
    title1: "参数字段",
    title2: "变更前",
    title3: "变更后",
  },
  modifyLog: {
    actionSheet: "操作类型",
    btn1: "修改",
    btn2: "下发同步",
    title1: "操作方式",
    title2: "线上",
    title3: "线下",
    title4: "操作平台",
    title5: "操作人",
    title6: "操作时间",
    btn3: "变更参数",
    btn4: "查看",
  },
  orderChargeCourse: {
    title1: "桩端信息",
    title2: "模块信息",
  },
  orderDetailInfo: {
    title1: "业务订单号",
    title2: "平台订单号",
    title3: "车型号",
    title4: "车牌号",
    title5: "车辆VIN码",
    title6: "充电时间",
    title7: "实际充电时间",
    title8: "设备编号",
    title9: "充电时长",
    title10: "电站名称",
    title11: "充电电量(度)",
    title12: "充电状态",
    state1: "启动中",
    state2: "充电中",
    state3: "充电完成",
    title13: "解锁码",
    title14: "停止原因",
  },
  powerMoudleChargeCourse: {
    brand1: "台达",
    brand2: "星星",
    brand3: "中兴",
    title1: "故障信息",
    msg1: "电压",
    msg2: "电流",
    msg3: "温度",
    wz1: "订单号",
    wz3: "暂无数据",
  },
  stubChargeCourse: {
    title1: "桩端输出电压",
    title2: "车端需求电压",
    title3: "桩端输出电流",
    title4: "车端需求电流",
    title5: "电量",
    title6: "电池温度",
    title7: "枪端温度",
    title8: "桩端温度",
    title9: "电压",
    title10: "电流",
    title11: "SOC",
    title12: "电量",
    title13: "温度",
    title14: "枪温",
    title15: "CP电压",
    title16: "电网频率",
    title17: "火线温度",
    title18: "继电器温度",
  },
  stubGroupDetailInfo: {
    projectOrder: "项目编号",
    title1: "基本信息",
    title2: "电站ID",
    title3: "电站名称",
    title4: "所在城市",
    title5: "电站地址",
    title6: "非直营",
    title7: "直营",
    title8: "--",
    title9: "运营类型",
    title10: "电站类型",
    title12: "站点类型",
    title13: "电压上限",
    title14: "电压下限",
    title15: "实时功率",
    title16: "最大功率",
    title17: "辅助电压",
    title18: "近3天成功充电信息",
    title19: "固件版本",
    title20: "固件型号",
    title21: "硬件信息",
    title22: "iccid卡号",
    title23: "状态日志",
    title24: "服务时间",
    title25: "是否带枪",
    title26: "车位引导",
    title27: "车位描述",
    title28: "停车费",
    title29: "占位规则",
    title30: "电站公告",
    title31: "开放范围",
    title32: "电站状态",
    title33: "资产归属",
    title34: "运营方",
    title35: "启用时间",
    title36: "支持第三方充电企业",
    title37: "活动详情",

    title38: "直流设备",
    title39: "交流设备",
    title40: "充电价格",
    title41: "结算对象",
    title42: "充电信息",
    title43: "支持的互联互通企业",
    title44: "首次上线时间",
    title45: "放电价格",
    no: "否",
    yes: "是",
    wz1: "固件信息",
    stubGroupType1: "公共",
    stubGroupType2: "个人",
    stubGroupType3: "专用开放",
    stubGroupType4: "专用内部",

    operationType1: "非自营",
    operationType2: "自营",
    operationType3: "非自营-全流量托管",
    operationType4: "非自营-设备托管",
  },
  stubDetailInfo: {
    title1: "基本信息",
    title2: "设备编号",
    title3: "所属电站",
    title4: "设备名称",
    title5: "设备类型",
    title6: "交流电",
    title7: "直流电",
    title8: "交直流",
    title9: "设备型号",
    title10: "设备状态",
    title11: "状态日志",
    title12: "是否带枪",
    title13: "电压上限",
    title14: "电压下限",
    title15: "实时功率",
    title16: "最大功率",
    title17: "辅助电压",
    title18: "软件信息",
    title19: "固件版本",
    title20: "固件型号",
    title21: "硬件信息",
    title22: "iccid卡号",
    title23: "状态日志",
    no: "否",
    yes: "是",
    wz1: "固件信息",
  },
  stubOpLogInfo: {
    placeholder111: "请选择查询起止日期",
    title111: "起止日期",
    btn111: "查询",
    placeholder1: "请输入设备编号",
    title1: "设备编号",
    placeholder2: "请输入电站名称",
    title2: "电站名称",
    placeholder3: "请输入电表编号",
    placeholder4: "请输入配电柜编号",
    title3: "电表编号",
    title4: "全部",
    title5: "交流电",
    title6: "直流电",
    title7: "交直流",
    title8: "请选择",
    title9: "设备类型",
    title10: "请选择",
    title11: "设备型号",
    title12: "请选择",
    title13: "固件版本",
    title14: "请选择",
    title15: "固件型号",
    title16: "查询",
    title17: "设备编号",
    title18: "所属电站",
    title19: "设备类型",
    title20: "交流电",
    title21: "直流电",
    title22: "交直流",
    title23: "未知",
    title24: "设备型号",
    title25: "固件版本",
    title26: "固件型号",
    title27: "设备状态",
    action: "操作",
    btn1: "设备详情",
    btn2: "修改状态",
    btn3: "设备详情",
    btn4: "基础信息",
    btn5: "订单信息",
    btn6: "状态修改",
    btn7: "配置信息",
    btn8: "导出",
    btn9: "新增维修记录",
    btn10: "编辑维修记录",
    title28: "设备编号",
    title29: "查询",
    title30: "配电柜编号",
    dw: "天",
    hour: "时",
    minute: "分",
    second: "秒",
    btn: "设备列表",
    wz1: "请输入配电柜编号",
    wz2: "配电柜编号",
    wz3: "固件信息",
    wz4: "设备编号",
    wz5: "配置信息",
    wz6: "模块信息",
    wz7: "获取固件信息",
    wz8: "固件升级",
    wz9: "地区",
    onStatus: "启用",
    downStatus: "禁用",
  },
  tenceCompanyM: {
    placeholder1: "请输入设备编号",
    title1: "设备编号",
    placeholder2: "请输入电站名称",
    title2: "电站名称",
    placeholder3: "请输入电表编号",
    placeholder4: "请输入配电柜编号",
    title3: "电表编号",
    title4: "全部",
    title5: "交流电",
    title6: "直流电",
    title7: "交直流",
    title8: "请选择",
    title9: "设备类型",
    title10: "请选择",
    title11: "设备型号",
    title12: "请选择",
    title13: "固件版本",
    title14: "请选择",
    title15: "固件型号",
    title16: "查询",
    title17: "设备编号",
    title18: "所属电站",
    title19: "设备类型",
    title20: "交流电",
    title21: "直流电",
    title22: "交直流",
    title23: "未知",
    title24: "设备型号",
    title25: "固件版本",
    title26: "固件型号",
    title27: "设备状态",
    action: "操作",
    btn1: "设备详情",
    btn2: "修改状态",
    btn3: "设备详情",
    btn4: "基础信息",
    btn5: "订单信息",
    btn6: "状态修改",
    btn7: "配置信息",
    btn8: "导出",
    btn9: "新增质保供应商",
    btn10: "编辑质保供应商",
    btn11: "编辑城市类别",
    title28: "设备编号",
    title29: "查询",
    title30: "配电柜编号",
    dw: "天",
    hour: "时",
    minute: "分",
    second: "秒",
    btn: "设备列表",
    wz1: "请输入配电柜编号",
    wz2: "配电柜编号",
    wz3: "固件信息",
    wz4: "设备编号",
    wz5: "配置信息",
    wz6: "模块信息",
    wz7: "获取固件信息",
    wz8: "固件升级",
    wz9: "地区",
    onStatus: "启用",
    downStatus: "禁用",
  },
  watchExcManage: {
    btn10: "编辑监控事件",
    title1: "请输入",
    title2: "事件名称",
    title3: "请选择运维等级",
    title4: "运维等级",
    title5: "查询",
    title6: "创建时间",
    title7: "监控范围",
    title8: "告警条件",
    action: "操作",
    all: "全部",
  },
  stubList: {
    placeholder1: "请输入设备编号",
    title1: "设备编号",
    placeholder2: "请输入电站名称",
    title2: "电站名称",
    placeholder3: "请输入电表编号",
    placeholder4: "请输入配电柜编号",
    title3: "电表编号",
    title4: "全部",
    title5: "交流电",
    title6: "直流电",
    title7: "交直流",
    title8: "请选择",
    title9: "设备类型",
    title10: "请选择",
    title11: "设备型号",
    title12: "请选择",
    title13: "固件版本",
    title14: "请选择",
    title15: "固件型号",
    title16: "查询",
    title17: "设备编号",
    title18: "所属电站",
    title19: "设备类型",
    title20: "交流电",
    title21: "直流电",
    title22: "交直流",
    title23: "未知",
    title24: "设备型号",
    title25: "固件版本",
    title26: "固件型号",
    title27: "设备状态",
    action: "操作",
    btn1: "设备详情",
    btn2: "修改状态",
    btn3: "设备详情",
    btn4: "基础信息",
    btn5: "订单信息",
    btn6: "状态修改",
    btn7: "配置信息",
    btn8: "导出",
    btn9: "新增巡检费用",
    btn10: "编辑巡检费用",
    btn11: "修改质保",
    btn12: "批量设置质保",
    btn13: "批量导入质保",
    title28: "设备编号",
    title29: "查询",
    title30: "配电柜编号",
    dw: "天",
    hour: "时",
    minute: "分",
    second: "秒",
    btn: "设备列表",
    wz1: "请输入配电柜编号",
    wz2: "配电柜编号",
    wz3: "固件信息",
    wz4: "设备编号",
    wz5: "配置信息",
    wz6: "模块信息",
    wz7: "获取固件信息",
    wz8: "固件升级",
    wz9: "地区",
    wz10: "维修记录",
    onStatus: "启用",
    downStatus: "禁用",
  },
  stubOrderInfo: {
    placeholder1: "年/月/日",
    title1: "订单结束时间",
    btn1: "查询",
    btn2: "导出",
    title2: "平台订单号",
    title3: "充电时间",
    title4: "电量(度)",
    title5: "充电状态",
    title6: "启动中",
    title7: "充电中",
    title8: "充电完成",
    title9: "停止原因",
    action: "操作",
    btn3: "订单详情",
    btn4: "充电过程",
    btn5: "充电过程",
    btn6: "订单详情",
    wz1: "请输入业务订单号",
    wz2: "业务订单号",
    wz3: "请输入平台订单号",
    wz4: "平台订单号",
    wz5: "请输入设备编号",
    wz6: "设备编号",
    wz7: "请输入用户编号",
    wz8: "用户编号",
    wz9: "请输入充电应用",
    wz10: "充电应用",
    wz11: "订单结束时间",
    wz12: "请选择停止原因",
    wz13: "停止原因",
    wz14: "电站",
    wz15: "地区",
    wz16: "实际充电时间",
    wz17: "充电时长",
    wz18: "充电数据",
    wz19: "模块数据",
    wz20: "平台日志",
    wz21: "桩连平台日志",
  },
  stubParamsConfig: {
    title1: "配置字段(字段范围)",
    title2: "设备端配置",
    title3: "平台端配置",
    btn3: "下载",
    title4: "平台端配置变更时间",
    title5: "配置字段(字段范围)",
    title6: "设备端配置",
    title7: "平台端配置",
    msg1: "信息获取可能会有延迟，您可以点击“获取设备端配置”查询最新信息",
    msg2: "操作成功",
    msg3: "无修改数据，请点击取消关闭窗口",
    msg4: "命令下发成功",
    title8: "设备编号",
    title9: "电站名称",
    title10: "设备端配置校验码",
    title11: "设备端配置变更时间",
    title12: "设备端配置上报时间",
    title13: "平台端配置校验码",
    title14: "平台端配置下发时间",
    title15: "平台端最后修改时间",
    title16: "配置模板",
    title17: "获取设备端配置",
    title18: "修改平台配置",
    title19: "使用平台端配置",
    title20: "使用设备端配置",
    title21: "变更记录",
    title22: "配置刷新",
    btn1: "取消",
    btn2: "保存",
    wz1: "配置信息",
  },
  stubStatusLog: {
    title1: "月份选择",
    btn1: "查询",
    btn2: "导出",
    title2: "上报时间",
    title3: "状态码",
    title4: "状态信息",
    title5: "用户账号",
  },
  chooseStation: {
    btn1: "查询",
  },
  chooseStubId: {
    btn1: "查询",
  },
  stubStatusUpdate: {
    msg1: "操作成功",
    msg2_1: "内容长度请在",
    msg2_2: "到",
    msg2_3: "1之间",
    title1: "修改状态",
    placeholder1: "请选择要修改的状态",
    placeholder2: "请选择",
    state1: "维护中",
    state2: "离线",
    title2: "变更原因",
    placeholder3: "请输入变更原因",
    btn1: "确认",
  },

  bindModelMessage: {
    msg1: "操作成功",
    msg2_1: "内容长度请在",
    msg2_2: "到",
    msg2_3: "1之间",
    title1: "邮件",
    placeholder1: "请选择要修改的状态",
    placeholder2: "请选择",
    state1: "维护中",
    state2: "离线",
    title2: "变更原因",
    placeholder3: "请输入变更原因",
    btn1: "确认",
  },

  stubBindLock: {
    msg1: "操作成功",
    msg2_1: "内容长度请在",
    msg2_2: "到",
    msg2_3: "1之间",
    title1: "修改状态",
    placeholder1: "请选择要修改的状态",
    placeholder2: "请选择",
    state1: "维护中",
    state2: "离线",
    title2: "变更原因",
    placeholder3: "请输入变更原因",
    btn1: "确认",
  },
  seeStubTenceInfo: {
    msg1: "操作成功",
    msg2_1: "内容长度请在",
    msg2_2: "到",
    msg2_3: "1之间",
    title1: "修改状态",
    placeholder1: "请选择要修改的状态",
    placeholder2: "请选择",
    state1: "维护中",
    state2: "离线",
    title2: "变更原因",
    placeholder3: "请输入变更原因",
    btn1: "确认",
  },
  EditOrAddStuOpLog: {
    msg1: "操作成功",
    msg2_1: "内容长度请在",
    msg2_2: "到",
    msg2_3: "1之间",
    title1: "设备编号",
    placeholder1: "请选择要设备类型",
    placeholder2: "请选择",
    state1: "维护中",
    state2: "离线",
    title2: "类型",
    title3: "内容",
    title4: "费用",
    title5: "电站",
    title6: "维修对象",
    placeholder3: "请输入变更原因",
    btn1: "确认",
  },
  EditOrAddTenceCom: {
    msg1: "操作成功",
    msg2_1: "内容长度请在",
    msg2_2: "到",
    msg2_3: "1之间",
    title1: "设备类型",
    placeholder1: "请选择要设备类型",
    placeholder2: "请选择",
    state1: "维护中",
    state2: "离线",
    title2: "设备型号",
    title3: "供应商名称",
    placeholder3: "请输入变更原因",
    btn1: "确认",
  },
  CfgLoogUpInsert: {
    msg1: "操作成功",
    msg2_1: "内容长度请在",
    msg2_2: "到",
    msg2_3: "1之间",
    title1: "设备类型",
    placeholder1: "请选择要设备类型",
    placeholder2: "请选择",
    state1: "维护中",
    state2: "离线",
    title2: "设备型号",
    title3: "巡检费用",
    placeholder3: "请输入变更原因",
    btn1: "确认",
  },
  EventMonitorCfgUpdate: {
    msg1: "操作成功",
    title1: "运维等级",
    title2: "事件名称",
    title3: "大于环境温度",
    title4: "同组模块相差不能大于",
    title5: "不同品牌模块绝对值差",
    title6: "电流最大最小差值大于",
    title7: "异常采样点",
    title8: "异常订单数",
    title9: "连续产生异常订单用户数",
    title10: "24小时掉线次数",
    title11: "异常扣费金额大于",
    title12: "离线时长（秒）大于",
    title13: "充电量大于",
    placeholder1: "请选择运维等级",
    btn1: "确认",
  },
  stubGroupList: {
    placeholder1: "请选择地区",
    title1: "地区",
    title2: "电站名称",
    btn1: "查询",
    title3: "直流数",
    title4: "交流数",
    title5: "电站地区",
    title6: "请选择",
    title7: "非直营",
    title8: "直营",
    title9: "公共",
    title10: "个人",
    title11: "专用开放",
    title12: "专用内部",
    action: "操作",
    btn2: "设备列表",
    btn3: "设备快速查询",
    btn4: "配电柜列表",
    btn5: "配电柜管理",
    btn6: "运营类型",
    btn7: "场站类型",
    btn8: "订单列表",
    all: "全部",
    title23: "未知",
  },
  appkeySuccessRate: {
    title1: "排名",
    title2: "渠道",
    title3: "总订单数",
    title4: "失败订单数",
    title5: "成功率",
    tool1: "成功率=充电成功订单/总充电订单",
    btn1: "订单列表",
    wz1: "订单详情",
  },
  chargeOrderDetail: {
    btn1: "导出",
    title1: "订单编号",
    title2: "设备编号",
    title3: "充电时间",
    title4: "用户编号",
    title5: "电量",
    title6: "车辆VIN",
    title7: "车型",
    title8: "充电渠道",
    title9: "停止原因",
    action: "操作",
    btn2: "充电过程",
  },
  chargSuccess: {
    placeholder1: "请选择日期范围",
    title1: "日期",
    placeholder2: "请选择地区",
    title2: "地区",
    operationMode1: "全部",
    operationMode2: "他营",
    operationMode3: "联营",
    operationMode4: "星充直营",
    operationMode5: "加盟直营",
    operationMode6: "互联互通",
    operationMode7: "人人电站",
    placeholder3: "请选择",
    title3: "运营类型",
    all: "全部",
    type1: "交流",
    type2: "直流",
    placeholder4: "请选择",
    title4: "设备类型",
    btn1: "查询",
    title5: "地区交直流桩充电成功率",
    title6: "不同固件版本充电成功率",
    title7: "交直流桩跳枪原因",
    title8: "TOP50渠道充电成功率",
  },
  citySuccessRate: {
    title1: "排名",
    title2: "地区",
    title3: "订单数",
    title4: "总计",
    msg1: "交流",
    msg2: "直流",
    msg3: "总",
    title5: "成功订单数",
    title6: "失败订单数",
    title7: "成功率",
    tool1: "成功率=充电成功订单/总充电订单",
    title8: "总计",
    title9: "成功订单数",
    title10: "失败订单数",
    title11: "充电成功率",
    title12: "订单数",
    title13: "成功率",
    title14: "成功订单数",
    title15: "失败订单数",
    title16: "充电成功率",
    btn1: "图",
    btn2: "表",
    wz1: "订单详情",
  },
  endCodeSuccessRate: {
    title1: "停止原因",
    title2: "异常失败订单",
    title3: "占比",
    title4: "订单列表",
    wz1: "订单详情",
  },
  versionTypeSuccessRate: {
    title1: "版本",
    title2: "订单数",
    msg1: "交流",
    msg2: "直流",
    msg3: "总",
    title3: "成功订单数",
    title4: "失败订单数",
    title5: "成功率",
    tool1: "成功率=充电成功订单/总充电订单",
    all: "总计",
    type1: "老国标1.0",
    type2: "新国标2.0",
    type3: "新国标2.1",
    type4: "测试版本9开头",
    msg4: "未知",
    title6: "成功订单数",
    title7: "失败订单数",
    title8: "充电成功率",
    title9: "订单数",
    title10: "成功率",
    title11: "成功订单数",
    title12: "失败订单数",
    title13: "充电成功率",
    btn1: "图",
    btn2: "表",
    wz1: "订单详情",
  },
  stubDate: {
    title1: "日期",
    title2: "平均运营时长",
    tool1:
      "运营时长：空闲时长（包含插枪空闲时长） + 充电中时长 + 车位占用时长 + 故障时长 + 离线时长 + 升级中时长 + 预约等待充电中时长 + 储能中时长 + 在线预约中时长 + 充满时长；",
    tool1_2: "平均运营时长：所有统计设备的平均运营时长。",
    title3: "故障桩",
    title4: "平均故障时长",
    tool2: "故障时长：设备变更为故障状态开始计时到设备变更为另一个状态为止的时间段。",
    tool2_2: "平均故障时长：所有故障设备的平均故障时长。",
    title5: "故障率",
    tool3: "故障率=故障时长/运营时长",
    title6: "离线桩",
    title7: "平均离线时长",
    tool4: "离线时长：设备变更为离线状态开始计时到设备变更为另一个状态为止的时间段。",
    tool4_2: "平均离线时长：所有离线设备的平均故障时长。",
    title8: "离线率",
    tool5: "离线率=离线时长/运营时长",
    title9: "平均完好时长",
    tool6: "完好时长=运营时长 - 故障时长 -离线时长。",
    tool6_2: "平均完好时长：所有统计设备的平均完好时长。",
    tool7: "完好率=(运营时长-离线时长-故障时长)/运营时长",
    dw: "天",
    hour: "时",
    minute: "分",
    second: "秒",
    totle: "总计",
    title10: "完好率",
    title11: "离线率",
    title12: "故障率",
    data: "日期",
  },
  stubDetail: {
    state1: "故障",
    state2: "离线",
    btn1: "设备快速查询",
    btn2: "导出",
    title1: "设备编号",
    title2: "所属电站",
    title3: "设备类型",
    type1: "交流",
    type2: "直流",
    type3: "交直流",
    type4: "未知",
    title4: "运营类型",
    operationMode1: "他营",
    operationMode2: "联营",
    operationMode3: "星充自营",
    operationMode4: "加盟直营",
    operationMode5: "互联互通",
    operationMode6: "人人电站",
    operationMode7: "未知",
    title5: "设备型号",
    title6: "固件型号",
    title7: "固件版本",
    title8: "时长",
    title9: "次数",
    title10: "最后一次",
    title11: "时间",
    title12: "地区",
    dw: "天",
    hour: "时",
    minute: "分",
    second: "秒",
  },
  stubIntact: {
    placeholder1: "请选择日期范围",
    title1: "日期",
    placeholder2: "请选择地区",
    title2: "地区",
    no: "否",
    yes: "是",
    msg1: "显示下级",
    operationMode1: "全部",
    operationMode2: "他营",
    operationMode3: "联营",
    operationMode4: "星充直营",
    operationMode5: "加盟直营",
    operationMode6: "互联互通",
    operationMode7: "人人电站",
    placeholder3: "请选择",
    title3: "运营类型",
    type0: "全部",
    type1: "交流",
    type2: "直流",
    placeholder4: "请选择",
    title4: "设备类型",
    areaFirst: "地区优先",
    operationFirst: "运营类型优先",
    placeholder5: "请选择",
    title5: "排序",
    btn1: "查询",
    title6: "按日期呈现",
    title7: "按分类呈现",
    wz1: "地区细分",
  },
  stubType: {
    title1: "设备类型",
    title2: "平均运营时长",
    tool1:
      "运营时长：空闲时长（包含插枪空闲时长） + 充电中时长 + 车位占用时长 + 故障时长 + 离线时长 + 升级中时长 + 预约等待充电中时长 + 储能中时长 + 在线预约中时长 + 充满时长；",
    tool1_2: "平均运营时长：所有统计设备的平均运营时长。",
    title3: "故障桩",
    tool2: "故障时长：设备变更为故障状态开始计时到设备变更为另一个状态为止的时间段。",
    tool2_2: "平均故障时长：所有故障设备的平均故障时长。",
    title4: "平均故障时长",
    title5: "故障率",
    tool3: "故障率=故障时长/运营时长",
    title6: "离线桩",
    title7: "总计",
    tool4: "离线时长：设备变更为离线状态开始计时到设备变更为另一个状态为止的时间段。",
    tool4_2: "平均离线时长：所有离线设备的平均故障时长。",
    title8: "平均离线时长",
    tool5: "离线率=离线时长/运营时长",
    title9: "离线率",
    tool6: "完好时长=运营时长 - 故障时长 -离线时长。",
    tool6_2: "平均完好时长：所有统计设备的平均完好时长。",
    title10: "平均完好时长",
    title11: "完好率",
    tool7: "完好率=(运营时长-离线时长-故障时长)/运营时长",
    title12: "设备列表",
    title13: "地区",
    title14: "运营类型",
    dw: "天",
    hour: "时",
    minute: "分",
    second: "秒",
  },
  equipmentIntact: {
    placeholder1: "请选择日期",
    title1: "日期",
    placeholder2: "选择日期",
    btn1: "查询",
    btn2: "数据导出",
    title2: "运营类型",
    operationMode1: "他营",
    operationMode2: "联营",
    operationMode3: "星充自营",
    operationMode4: "加盟直营",
    operationMode5: "互联互通",
    operationMode6: "人人电站",
    operationMode7: "未知",
    title3: "桩总数",
    type1: "交流",
    type2: "直流",
    totle: "总数",
    title4: "在建桩",
    title5: "已投建桩",
    title6: "维护桩",
    title7: "可用桩",
    title8: "可用率",
    title9: "正常运营桩",
    title10: "完好率",
    title11: "无运营价值政策桩",
    title12: "完好率(剔除政策桩)",
    title13: "桩运营类型分析",
  },
  crcExceptionList: {
    placeholder1: "请输入设备编号",
    title1: "设备编号",
    placeholder: "请选择",
    title2: "设备型号",
    title3: "固件查询",
    type0: "全部",
    type1: "交流电",
    type2: "直流电",
    type3: "交直流",
    title4: "设备类型",
    btn1: "查询",
    btn2: "批量使用平台配置",
    btn3: "批量使用设备配置",
    title5: "设备编号",
    title6: "平台CRC",
    title7: "设备CRC",
    title8: "设备类型",
    title9: "交流电",
    title10: "直流电",
    title11: "交直流",
    result1: "未知",
    title12: "设备型号",
    title13: "固件信息",
    action: "操作",
    btn4: "查看配置",
    btn5: "使用平台配置",
    btn6: "使用设备配置",
    msg1: "操作成功",
    msg2: "请至少选择一项",
    msg3: "最多批处理100条",
    msg5: "配置信息",
  },
  addEquipment: {
    msg1: "至少选择一个电站",
    msg2: "所选电站已存在",
    msg3: "添加成功",
    msg4: "至少选择一个电站",
    msg5: "所选电站未添加或已被删除",
    msg6: "删除成功",
    msg7: "至少选择一个电站",
    msg8: "应用成功",
    msg9: "添加枪端",
    bnt1: "删除电站",
    msg10: "最多显示100个电站",
  },
  cfgChangeTaskBuild: {
    btn1: "配置上传",
    msg1: "配置内容不能为空",
    msg2: "操作成功",
    msg3: "上传成功",
    btn2: "重新上传",
    title1: "任务名称",
    title2: "上传的配置文件",
    title3: "配置内容",
    title4: "校验结果",
    title5: "校验无误",
    title6: "项配置异常",
    btn5: "配置下载",
    btn3: "确定",
    btn4: "取消",
    title7: "备注",
  },
  cfgExport: {
    placeholder1: "请选择枪编号及配置项",
    title1: "任务范围",
    title2: "配置选择",
    placeholder: "请选择",
    btn1: "配置导出",
    btn2: "取消",
    btn3: "添加",
  },
  equipmentListModal: {
    btn1: "选择当前",
    btn2: "批量添加",
    placeholder1: "请选择地区",
    title1: "地区",
    title2: "电站名称",
    btn3: "查询",
    title3: "枪编号",
    title4: "地区",
    title5: "电站名称",
    btn5: "操作",
    btn4: "添加",
    msg1: "不能按照省来查询",
    title6: "电站查询",
    btn6: "覆盖选择",
  },
  equipmentListModalDel: {
    title1: "地区",
    placeholder1: "请选择地区",
    placeholder: "请选择",
    all: "全部",
    type1: "自营",
    type2: "非自营",
    title2: "运营类型",
    title3: "电站名称",
    btn1: "查询",
    btn2: "删除",
    btn3: "电站查询",
    action: "操作",
  },
  stationListModal: {
    select: "全选/不选",
    btn1: "覆盖选择",
    btn2: "批量添加",
    title1: "地区",
    placeholder1: "请选择地区",
    title2: "电站名称",
    btn3: "查询",
    title8: "地区",
    placeholder2: "请选择地区",
    title3: "电站名称",
    btn4: "查询",
    title4: "枪编号",
    title5: "地区",
    title6: "电站名称",
    btn5: "操作",
    btn6: "添加",
    title7: "电站查询",
  },
  taskExecuteResult: {
    title1: "设备编号",
    msg1: "成功",
    msg2: "修改平台配置失败",
    msg3: "配置下发失败",
  },
  taskManagement: {
    placeholder1: "请输入操作人",
    title1: "创建人",
    all: "全部",
    btn1: "配置修改",
    btn2: "固件升级",
    placeholder: "请选择",
    title11: "任务类型",
    state1: "未执行",
    state2: "已执行",
    title2: "任务状态",
    placeholder2: "年/月/日",
    title3: "创建时间",
    btn3: "查询",
    btn4: "新建任务",
    btn5: "配置导出",
    actionSheet: "操作名称",
    title4: "创建人",
    title5: "创建时间",
    title6: "任务类型",
    btn6: "配置修改",
    btn7: "固件升级",
    title7: "操作电桩数量",
    title8: "任务状态",
    state3: "未执行",
    title10: "执行结果",
    title9: "备注",
    action: "操作",
    btn8: "任务执行",
    msg1: "操作成功",
    btn9: "查看任务",
    btn10: "删除",
    msg2: "操作成功",
    btn11: "任务选择",
    btn12: "配置导出",
    btn13: "查看任务",
    btn14: "结果详情",
  },
  taskSelect: {
    placeholder1: "请选择执行的任务类型",
    btn1: "配置修改",
    btn2: "创建任务",
    modaltitle1: "新建任务",
  },
  account: {
    msg1: "暂无数据",
    btn1: "添加用户",
    btn2: "分配角色",
    title1: "用户管理",
    title2: "用户列表",
    title3: "用户名称",
    title4: "用户电话",
    title5: "用户邮箱",
    action: "操作",
    btn3: "分配角色",
    placeholder1: "请输入用户名称",
    title6: "用户名称",
    btn4: "查询",
    btn5: "添加用户",
    wz1: "账号",
  },
  addAccountModal: {
    placeholder1: "请先查询用户名称",
    title1: "用户名称",
    btn1: "查询",
    title2: "电话",
    title3: "邮箱",
    action: "操作",
    btn2: "添加",
    msg1: "添加成功",
  },
  dispatchRoleModal: {
    title1: "所有角色",
    title2: "已选角色",
    placeholder1: "请输入搜索内容",
    msg1: "暂无选项",
    dw1: "项",
    btn1: "确定",
    btn2: "清空",
  },
  dispatchPermissionsModal: {
    title1: "权限名称",
    placeholder1: "请输入权限名称",
    title2: "未选权限",
    title3: "已选权限",
    placeholder2: "请搜索",
    msg1: "暂无选项",
    dw1: "条",
    btn1: "确定",
    btn2: "清空",
    title4: "权限名称",
    placeholder3: "请输入权限名称",
    placeholder4: "请搜索",
  },
  permissionList: {
    title1: "权限设置",
    title2: "菜单读权限",
    title3: "菜单分配权限",
    title4: "数据地区查询权限",
    title5: "权限名称",
    placeholder1: "请输入权限名称",
    btn1: "查询",
    btn2: "新增权限",
    title6: "权限名称",
    action: "操作",
    btn3: "编辑权限",
    btn4: "删除",
  },
  editRoleModal: {
    title1: "角色名称",
    placeholder1: "请输入角色名称",
    choose1: "所有权限",
    choose2: "已选权限",
    placeholder2: "请输入搜索内容",
    msg1: "暂无选项",
    dw1: "项",
    btn1: "确定",
    title2: "角色名称",
    placeholder3: "请输入角色名称",
  },
  role: {
    title1: "角色设置",
    title2: "角色名称",
    action: "操作",
    btn1: "编辑角色",
    btn2: "删除",
    btn3: "新增角色",
  },
  roleList: {
    title1: "角色设置",
    title2: "角色名称",
    placeholder1: "请输入角色名称",
    btn1: "查询",
    btn2: "新增角色",
    title3: "角色名称",
    title4: "状态",
    state1: "正常",
    state2: "禁用",
    action: "操作",
    btn3: "编辑角色",
    btn4: "删除",
  },
  no_access: {
    msg1: "您暂时没有访问权限！",
    msg2: "后自动返回登录页面。",
    btn1: "返回首页",
  },
  no_connect: {
    msg3: "服务器或接口故障",
  },
  no_menu: {
    msg1: "你暂时没有菜单权限或者登录已超时，请联系管理员添加权限",
    msg2: "即将跳转登录页",
    wz1: "立即跳转",
  },
  nofound: {
    msg1: "您访问的页面不存在请重试！",
  },
  formCore: {
    msg1: "暂无选项",
    msg2: "接口请求失败",
    msg3: "Form横向布局请勿使用穿梭框",
    msg4: "内容长度请在",
    msg4_2: "到",
    msg4_3: "之间",
    msg5: "数值需≥",
    msg5_2: "或",
    msg5_3: "≤",
    msg6: "小数点位数需≤",
    msg7: "请输入正确的数值",
    msg8: "请输入正数",
    msg9: "数值需为≥",
    msg9_2: "或≤",
    msg9_3: "的正整数",
    msg10: "请输入正整数",
    msg11: "请输入非零正整数",
    msg12: "手机号码不正确",
    msg13: "请勾选",
    msg14: "校验",
    msg15: "不可跨年份查询",
    msg16: "最多选择",
    msg19: "天",
    msg17: "最少选择",
    msg18: "日期校验",
    placeholder1: "请输入内容",
    all: "全部",
  },
  gridTableCore: {
    msg1: "共计",
    msg1_2: "条",
    msg2: "暂无",
    msg3: "预览图片",
    msg4: "确认要",
    msg4_2: "吗",
    btn1: "确认",
    btn2: "取消",
    btn3: "更多",
    msg5: "构建表格失败",
    msg6: "构建表格中",
    wz1: "暂无数据",
  },
  scLayoutTab: {
    msg1: "请关闭多余窗口！",
    btn1: "注销用户",
    web1: "谷歌",
    web2: "360极速",
    webc: "推荐浏览器：",
    msg2: "版本号",
    company: "万帮星星充电科技有限公司",
    title1: "修改密码",
    lan1: "中文",
    lan2: "英文",
    lan3: "西班牙语",
    wz1: "修改密码",
  },
  fetchHandler: {
    msg1: "无此类别",
    msg2: "未找到桩群对应的占位计费规则",
  },
  moduleList: {
    state1: "全部",
    state2: "正常",
    state3: "故障",
    placeholder1: "请输入需要查询的模块编号",
    placeholder2: "请输入需要查询的设备编号",
    placeholder3: "请输入需要查询的电站名称",
    title1: "设备编号",
    placeholder3: "请选择",
    title2: "模块编号",
    title3: "设备编号",
    title4: "品牌",
    title6: "故障信息",
    title5: "模块类型",
    value1: "kw低压",
    value2: "kw高压",
    action: "操作",
    modalTitle1: "历史设备",
    brand1: "台达",
    brand2: "星星",
    brand3: "中兴",
    btn1: "查询",
    dw: "天",
    hour: "时",
    minute: "分",
    second: "秒",
    wz1: "故障信息",
    wz2: "运行时长",
    wz3: "故障日志",
    wz4: "场站名称",
    areaName: "地区",
  },
  moduleInfo: {
    placeholder1: "请选择查询起止日期",
    title1: "起止日期",
    btn1: "查询",
  },
  historyStubInfo: {
    placeholder1: "请输入设备编号",
    title1: "设备编号",
    title2: "运行时长",
    btn1: "查询",
    dw: "天",
    hour: "时",
    minute: "分",
    second: "秒",
    wz1: "总计",
    wz2: "模块信息",
  },
  eventMonitoring: {
    placeholder1: "请输入事件名称",
    placeholder2: "请输入主体编号",
    title1: "主体编号",
    placeholder3: "请选择地区",
    title2: "地区",
    placeholder4: "请选择",
    title3: "运维等级",
    operationMode1: "全部",
    operationMode2: "他营",
    operationMode3: "联营",
    operationMode4: "星充直营",
    operationMode5: "加盟直营",
    operationMode6: "互联互通",
    operationMode7: "人人电站",
    placeholder: "请选择",
    title4: "运营类型",
    placeholder5: "请选择查询起止日期",
    title5: "日期",
    title6: "查询",
    title7: "事件名称",
    title8: "事件主体",
    title9: "主体编号",
    title10: "设备编号",
    title11: "运维等级",
    title12: "次数",
    title13: "上报时间",
    title14: "电站名称",
    title15: "地区",
    title16: "运营类型",
    title17: "设备型号",
    title18: "详情",
    action: "操作",
    btn1: "模块数据",
    wz1: "电源模块",
    wz2: "模块信息",
    all: "全部",
  },
  faultReportingList: {
    placeholder1: "请输入故障名称",
    title1: "故障名称",
    placeholder2: "请输入设备编号",
    title2: "设备编号",
    placeholder3: "请选择地区",
    title3: "地区",
    placeholder: "请选择",
    title4: "运维等级",
    title5: "运营类型",
    placeholder4: "请选择查询起止日期",
    title6: "日期",
    btn1: "查询",
    title7: "设备编号",
    title8: "状态码",
    title9: "故障名称",
    title10: "运维等级",
    title11: "次数",
    title12: "最新上报时间",
    title13: "电站名称",
    title14: "地区",
    title15: "运营类型",
    title16: "设备型号",
    wz3: "固件信息",
    title17: "固件型号",
    title18: "请选择",
    title19: "固件版本",
    operationMode1: "全部",
    operationMode2: "他营",
    operationMode3: "联营",
    operationMode4: "星充直营",
    operationMode5: "加盟直营",
    operationMode6: "互联互通",
    operationMode7: "人人电站",
    all: "全部",
  },
  exportBtn: {
    msg1: "没有数据",
    placeholder1: "请选择查询条件",
    btn1: "导出",
  },
  publicParam: {
    all: "全部",
    type1: "星星充电-APP",
    type2: "星星充电-SAAS",
    type3: "SAAS-星币账户",
    type4: "星星充电-微信",
    btn1: "筛选",
    btn2: "确定",
    btn3: "重置",
    msg1: "暂无数据",
  },
  TreeTransfer: {
    wz1: "条数据",
    wz2: "请输入搜索关键字",
    wz3: "源数据",
    wz4: "目的数据",
  },
  login3: {
    lan1: "中文",
    lan2: "英文",
    lan3: "西班牙语",
    wz1: "运维管理系统",
  },
  LoginEnterAccount: {
    wz1: "请输入账号",
    wz2: "账号登录",
  },
  AccountLogin: {
    wz1: "密码不能为空",
    wz2: "请输入正确的验证码",
    wz3: "请输入密码",
    wz4: "请输入验证码",
    wz5: "登录",
    wz6: "账号登陆",
  },
  addAccountModalIntel: {
    wz1: "账号必须为邮箱或手机号",
    wz2: "账号和用户名必填",
    wz3: "新增用户成功，请配置用户权限",
    wz4: "姓名",
    wz5: "请输入用户姓名",
    wz6: "账号",
    wz7: "请输入账号",
    wz8: "请输入账号（邮箱/手机）",
    wz9: "提交",
  },
  ChangePassword: {
    wz1: "原始密码不能为空",
    wz2: "请输入新密码",
    wz3: "请输入确认密码",
    wz4: "两次密码输入不一致，请重新输入",
    wz5: "修改密码成功",
    wz6: "原密码",
    wz7: "请输入原密码",
    wz8: "新密码",
    wz9: "请输入新密码",
    wz10: "确认密码",
    wz11: "请确认密码",
    wz12: "提交",
  },
  scModal: {
    text1: "确定",
    text2: "取消",
  },
};



// WEBPACK FOOTER //
// ./src/AntD/locale/zh-CN.messages.js